import React, { useState, ReactNode } from 'react';
import { ButtonLink } from './Styles.jsx';

interface ContainerProps {
  open: Function;
  theme: any;
  text: ReactNode;
  classx: any;
  id: any;
}

const ModalButton: React.FC<ContainerProps> = ({ open, theme, text, classx, id }) => {
  return (
    <ButtonLink id={id} className={classx} theme={theme} onClick={() => open()}>
       {text}
    </ButtonLink>
  );
};

export default ModalButton;
